[
  {
    "url": "https://[\\w.-]+\\.force\\.com/lightning/r/contact/\\w+/view",
    "elements": [
      {
        "name": "Full Name",
        "isSlotEncapsulated": "true",
        "selectors": [
          "section.tabContent.active.oneConsoleTab section.tabContent.active.oneConsoleTab .recordHomeFlexipage2",
          "section div.active .recordHomeFlexipage2"
        ],
        "slotContainerSelector": ".slds-page-header__title"
      },
      {
        "name": "Contact info",
        "isSlotEncapsulated": "true",
        "multiple": "true",
        "selectors": [
          "section.tabContent.active.oneConsoleTab section.tabContent.active.oneConsoleTab .recordHomeFlexipage2",
          "section div.active .recordHomeFlexipage2"
        ],
        "slotContainerSelector": ".fieldComponent"
      }
    ]
  },
  {
    "url": "https://[\\w.-]+\\.force\\.com/lightning/r/account/\\w+/view",
    "elements": [
      {
        "name": "Company Website",
        "isSlotEncapsulated": "true",
        "multiple": "true",
        "selectors": [
          "section.tabContent.active.oneConsoleTab section.tabContent.active.oneConsoleTab .recordHomeFlexipage2",
          "section div.active .recordHomeFlexipage2"
        ],
        "slotContainerSelector": ".fieldComponent"
      }
    ]
  },
  {
    "url": "https://[\\w.-]+\\.force\\.com/lightning/r/lead/\\w+/view",
    "elements": [
      {
        "name": "Full Name",
        "isSlotEncapsulated": "true",
        "selectors": [
          "section.tabContent.active.oneConsoleTab section.tabContent.active.oneConsoleTab .recordHomeFlexipage2",
          "section div.active .recordHomeFlexipage2"
        ],
        "slotContainerSelector": ".slds-page-header__title"
      },
      {
        "name": "Contact info",
        "isSlotEncapsulated": "true",
        "multiple": "true",
        "selectors": [
          "section.tabContent.active.oneConsoleTab section.tabContent.active.oneConsoleTab .recordHomeFlexipage2",
          "section div.active .recordHomeFlexipage2"
        ],
        "slotContainerSelector": ".fieldComponent"
      }
    ]
  }
]
